export default __webpack_public_path__ + "static/media/back-10.d0b6992e.svg";